import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

//REDUX SELECTOR
import { trackingIdAndAnonymousLocalSelector } from '../userTracking/state/trackingIdAndAnonymousLocalSelector';
import { trackingSessionIdSelector } from '../userTracking/state/trackingSessionIdSelector'
import { userLocationSelector } from '../markers/state/userLocationSelector'

//REDUX ACTIONS
import { toggleUserMenu } from './state/displayUserMenuAction ';

//UTILS
import { addActionToDbBasedOnElement } from '../global/UserTrackingUtils'
import { getCustomerInLS } from '../global/GlobalUtils'

//STYLE
import './UserMenu.css'
import cocoparksLogo from '../images/logo.png'
import ampLogo from '../images/customers/amp.png'
import saintdenisreunionLogo from '../images/customers/saintdenisreunion.png'
import quimperLogo from '../images/customers/quimper.jpg'
import landerneauLogo from '../images/customers/landerneau.png'
import livrygargan from '../images/customers/livrygargan.jpg'
import sancerreLogo from '../images/customers/sancerre.png'
import chulimogesLogo from '../images/customers/chulimoges.png'
import genasLogo from '../images/customers/genas.png'
import mennecyLogo from '../images/customers/mennecy.jpeg'
import leboulouLogo from '../images/customers/leboulou.png'
import marseilleairbusLogo from '../images/customers/marseilleairbus.png'

// Import the introduction content to get styling
import introData from '../cocoparksIntroduction/introductionTextContent.json'


function UserMenuIcon() {

    const dispatch = useDispatch()

    const trackingIdAndAnonymousLocal = useSelector( trackingIdAndAnonymousLocalSelector)
    const trackingSessionId = useSelector(trackingSessionIdSelector)
    const userLocation = useSelector(userLocationSelector)
    const config = useSelector((state) => state.config);

    function toggleUserMenuOnRight(status){
        dispatch(toggleUserMenu(status))
    }

    let image = null
    let customerStyles = {}
    
    switch (config.customer) {
        case 'amp': image = ampLogo; break;
        case 'saintdenisreunion': image = saintdenisreunionLogo; break;
        case 'quimper': image = quimperLogo; break;
        case 'landerneau': image = landerneauLogo; break;
        case 'livrygargan': image = livrygargan; break;
        case 'sancerre': image = sancerreLogo; break;
        case 'chulimoges': image = chulimogesLogo; break;
        case 'genas': image = genasLogo; break;
        case 'mennecy': image = mennecyLogo; break;
        case 'leboulou': image = leboulouLogo; break;
        case 'marseilleairbus': image = marseilleairbusLogo; break;
        default: image = cocoparksLogo; break;
    }
    
    // Get customer styles from JSON
    const customer = getCustomerInLS()
    if (customer && introData[customer] && introData[customer].styles) {
        customerStyles = introData[customer].styles
    }

    return (
        <button 
            disabled={ userLocation ? false : true}
            style={{borderStyle : "none", background: "none", padding: "0px", margin: "0px", marginRight: "5px"}} 
            onClick={()=> {toggleUserMenuOnRight(true); addActionToDbBasedOnElement("openLoginNav", trackingIdAndAnonymousLocal, trackingSessionId)}}
        >
            <img src={image} alt="Logo" style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: 'contain',
                padding: customerStyles?.menuLogoBorderColor ? "2px" : "0px",
                backgroundColor: customerStyles?.menuLogoBackgroundColor || 'white',
                border: customerStyles?.menuLogoBorderColor ? `2px solid ${customerStyles.menuLogoBorderColor}` : 'none',
            }} />
        </button>
    )
}

export default UserMenuIcon;